function YouTubeGetID(url) {
  url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return undefined !== url[2] ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
}

function parseVimeoIdFromUrl(vimeoUrl) {
  const regex =
    /(?:http[s]?:\/\/)?(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:\w+\/)videos\/|album\/(?:\d+\/)video\/|video\/|)(\d+)(?:\/(\w+))?(?:[#?]|$)/;
  const match = vimeoUrl.match(regex);
  if (match) {
    return [match[1], match[2]].filter(Boolean).join(':');
  }
  return null;
}

export const parseCoverUrl = (url) => {
  if (url.includes('youtube')) {
    const id = YouTubeGetID(url);
    return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
  } else if (url.includes('vimeo')) {
    const id = parseVimeoIdFromUrl(url);
    return `https://vumbnail.com/${id}.jpg`;
  }
};

export const getReactions = (data) => {
  const d = [];
  if (!data) return d;
  if (+data.thumbs_up) {
    d.push({
      count: data.thumbs_up,
      emoji: '👍',
    });
  }
  if (+data.heart) {
    d.push({
      count: data.heart,
      emoji: '❤️',
    });
  }
  if (+data.party) {
    d.push({
      count: data.party,
      emoji: '🎉',
    });
  }
  if (+data.folded_hands) {
    d.push({
      count: data.folded_hands,
      emoji: '🙏',
    });
  }
  return d;
};
